import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .required('Por favor, insira um email.')
    .email('Por favor, insira um e-mail válido'),
  password: Yup.string().required('Por favor, insira sua senha.'),
});
